import axios from 'axios';
import { newApiUrl, extApiKey } from '../../conf';
import {
  ConsumeCouponResponse,
  CouponDetailsResponse,
} from './ConsumeBenefitInterface';

interface ConsumeBenefitService {
  consumeBenefit(
    couponId: string,
    redeemingUser?: string
  ): Promise<ConsumeCouponResponse>;
  getCouponById(couponId: string): Promise<CouponDetailsResponse>;
}

export const useConsumeBenefitService = (): ConsumeBenefitService => {
  const consumeBenefit = async (couponId: string, redeemingUser?: string) => {
    const body = {
      couponId,
      ...(redeemingUser && { redeemingUser }),
    };
    try {
      const { data } = await axios.post<ConsumeCouponResponse>(
        newApiUrl + '/api/points/coupons/redeem',
        body,
        {
          headers: {
            'ext-api-key': extApiKey,
          },
        }
      );
      // console.log('Consume benefit response:', JSON.stringify(data, null, 2));
      return data;
    } catch (error) {
      // alert('Error consuming benefit: ' + error);
      return null;
    }
  };

  const getCouponById = async (couponId: string) => {
    try {
      const { data } = await axios.get<CouponDetailsResponse>(
        `${newApiUrl}/api/points/coupons/${couponId}/details`,
        {
          headers: {
            'ext-api-key': extApiKey,
          },
        }
      );
      // console.log('Coupon details:', JSON.stringify(data, null, 2));
      return data;
    } catch (error) {
      // alert('Error fetching coupon: ' + error);
      return null;
    }
  };

  return {
    consumeBenefit,
    getCouponById,
  };
};
